import { Helmet } from "react-helmet-async";

export const SEO = ({ title, description, canonical, schema, image }) => {
    const fullTitle = title
        ? `${title} | TruHeal India`
        : "TruHeal India — World-class medical tourism in India";
    const desc =
        description ||
        "TruHeal India helps international patients access world-class medical care in India — from free doctor opinions to medical visa, travel, hotel and hospital coordination.";

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            {canonical && <link rel="canonical" href={canonical} />}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            {image && <meta property="og:image" content={image} />}
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            {image && <meta name="twitter:image" content={image} />}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};
